<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.goods_label_orderGoodsNo') || '产品编号'"
          >
            <el-input v-model="formData.orderGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号'"
          >
            <el-input v-model="formData.identifyGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item
            :label="$l('INDEX.goods_label_orderGoodsName') || '产品名称'"
          >
            <el-input v-model="formData.orderGoodsDisplayName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.goods_label_isGroup') || '是否套装'">
            <el-input v-model="formData.v_isGroup" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.goods_package_size_label_goodsLength') || '长'"
          >
            <el-input v-model="formData.goodsLength" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.goods_package_size_label_goodsWidth') || '宽'"
          >
            <el-input v-model="formData.goodsWidth" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.goods_package_size_label_goodsHeight') || '高'"
          >
            <el-input v-model="formData.goodsHeight" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.goods_package_size_label_goodsWeight') || '净重'"
          >
            <el-input v-model="formData.goodsWeight" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    orderGoodsCode: { type: String, default: '' },
  },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsCode) return
      this.$api
        .pendingOrderGoodsPackageSizeDetailApi({
          orderGoodsCode: this.orderGoodsCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
